import { trpc } from '@/shared/api';

/** 어드민 배송비 설정(shippingFeeSettings.get, SUPER-86 D9) — 기본·제주 추가·도서산간 추가 금액(원, 부가세 포함)과 마지막 변경 시각·변경자. */
export const useShippingFeeSettingsQuery = () => trpc.shippingFeeSettings.get.useQuery();
